















import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { trim } from '@/util/helper';
const oss = require('bmh/oss');

@Component
export default class SingleFileUpload extends Vue {
  @Prop({ type: String, default: '' }) api!: string;
  @Prop({ type: String, default: 'pic.liuliangphone.com' }) domain!: string;
  @Prop({ type: String, default: '' }) readonly dir!: string;
  @Prop({ type: String, default: '' }) readonly accept!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Function }) readonly beforeUpload!: any;
  @Prop({ type: String, default: '' }) fileUrl!: string;

  loading: boolean = false;

  handleChange(info: any) {
    if (info.file.status === 'uploading') {
      this.loading = true;
      return;
    }
  }

  request(obj: any) {
    const { form_data, request_url } = oss(`${this.api}${trim(this.dir, '/')}/`, obj.file, this.domain);
    axios.post(request_url, form_data).then(() => {
      let fileSrc: string = obj.file.src;
      if (/^\/\//.test(fileSrc)) {
        fileSrc = `https:${fileSrc}`;
      }
      this.$emit('update:fileUrl', fileSrc);
      this.loading = false;
    });
  }
}
